module.exports = __webpack_public_path__ + "img/motor_power.svg";